import ListEmptyView from "./ListEmptyView";

import { useTheme } from "@/providers/ThemeProvider";

/**
 *
 */
interface Props {
  title?: string;
  description?: string;
}

/**
 * Container component for empty reports list state with theme handling
 * @param root0 - Component props
 * @param root0.title - Title text to display in the empty state
 * @param root0.description - Description text providing guidance to the user
 */
const ListEmptyContainer = ({
  title = "No Similar Players",
  description = "We could not find any similar players for this player.",
}: Props) => {
  const { resolvedTheme } = useTheme();
  const isDark = resolvedTheme === "dark";

  return (
    <ListEmptyView title={title} description={description} isDark={isDark} />
  );
};

export default ListEmptyContainer;
